import { html, mount } from '../../core/html.js';
import { api, put, session, refreshMe } from '../../core/api.js';
import { statusBadge, toast, withBusy } from '../../core/ui.js';
import { t } from '../../core/i18n.js';
import { fileField } from '../../core/controls.js';
import { workspace } from '../shared/layout.js';
import { telegramCard, bindTelegram } from '../shared/telegram.js';

const DOC_ACCEPT = 'application/pdf,image/jpeg,image/png,image/webp';

export async function render(main) {
  const body = workspace(main, 'host');
  await refreshMe();
  const h = session.me.host;
  const banks = session.config.banks;
  const canSubmit = !['VERIFIED', 'PENDING', 'SUSPENDED'].includes(h.verification_status);
  mount(body, html`<h1>${t('hostnav.settings')}</h1>
    <div class="stack">
    ${telegramCard()}
    <form id="vf" class="panel stack"><div class="spread"><h2 style="margin:0">${t('hsettings.verify_title')}</h2>${statusBadge(h.verification_status)}</div>
      ${h.verification_note ? html`<p class="small">${t('hsettings.admin_note')} <span data-ugc>${h.verification_note}</span></p>` : ''}
      ${h.verification_status === 'VERIFIED' ? html`<p class="small muted">${t('hsettings.verified_text')}</p>` : html`
        <p class="small muted">${t('hsettings.docs_private')}</p>
        <div class="field"><span>${t('hsettings.doc_id')}</span>${fileField('identification', { accept: DOC_ACCEPT, required: true })}</div>
        <div class="field"><span>${t('hsettings.doc_ssm')}</span>${fileField('business_registration', { accept: DOC_ACCEPT })}</div>
        <div class="field"><span>${t('hsettings.doc_property')}</span>${fileField('property_authorization', { accept: DOC_ACCEPT })}</div>
        <label class="field"><span>${t('hsettings.note')}</span><input class="input" name="note" maxlength="500"></label>
        <button class="btn btn-primary" ${canSubmit ? '' : 'disabled'}>${t(h.verification_status === 'PENDING' ? 'hsettings.under_review' : 'hsettings.submit_docs')}</button>`}
    </form>
    <form id="bf" class="panel stack"><h2>${t('hsettings.bank_title')}</h2>
      ${h.bank ? html`<p class="small">${t('hsettings.bank_current')} ${h.bank.bank_name} ${h.bank.account_number_masked}, <span data-ugc>${h.bank.account_holder}</span></p>` : ''}
      <label class="field"><span>${t('hsettings.bank')}</span><select class="input" name="bank_name" required>${banks.map((b) => html`<option ${h.bank?.bank_name === b ? 'selected' : ''}>${b}</option>`)}</select></label>
      <label class="field"><span>${t('hsettings.holder')}</span><input class="input" name="account_holder" required minlength="3" value="${h.bank?.account_holder || ''}"></label>
      <label class="field"><span>${t('hsettings.account_no')}</span><input class="input" name="account_number" required pattern="\\d{8,20}" data-pattern-msg="${t('validate.account_number')}" inputmode="numeric" autocomplete="off" placeholder="${h.bank ? t('hsettings.reenter') : ''}"></label>
      <p class="tiny muted">${t('hsettings.encrypted_note')}</p>
      <button class="btn btn-primary">${t('hsettings.save_bank')}</button></form>
    <form id="hf" class="panel stack"><h2>${t('hsettings.public_profile')}</h2>
      <label class="field"><span>${t('becomehost.display_name')}</span><input class="input" name="display_name" required minlength="2" value="${h.display_name}"></label>
      <label class="field"><span>${t('field.phone')}</span><input class="input" name="phone" type="tel" value="${h.phone || ''}"></label>
      <label class="field"><span>${t('becomehost.bio')}</span><textarea class="input" name="bio">${h.bio || ''}</textarea></label>
      <button class="btn btn-primary">${t('hsettings.save_profile')}</button></form></div>`);
  if (canSubmit) {
    body.querySelector('#vf').addEventListener('submit', (e) => {
      e.preventDefault();
      withBusy(e.submitter, async () => { await api('POST', '/api/host/verification', new FormData(e.target), { form: true }); toast(t('hsettings.docs_sent')); render(main); });
    });
  }
  bindTelegram(body);
  body.querySelector('#bf').onsubmit = (e) => {
    e.preventDefault();
    const f = Object.fromEntries(new FormData(e.target).entries());
    withBusy(e.submitter, async () => { await put('/api/host/bank', f); toast(t('hsettings.bank_saved')); render(main); });
  };
  body.querySelector('#hf').onsubmit = (e) => {
    e.preventDefault();
    const f = Object.fromEntries([...new FormData(e.target).entries()].filter(([, val]) => val));
    withBusy(e.submitter, async () => { await put('/api/host/profile', f); toast(t('hsettings.profile_saved')); render(main); });
  };
}
